import { pgTable, uuid, text, timestamp, index } from "drizzle-orm/pg-core";
import { organisations } from "./organisations";
export var EdgeType;
(function (EdgeType) {
    EdgeType["CITES"] = "cites";
    EdgeType["MENTIONS"] = "mentions";
    EdgeType["DERIVED_FROM"] = "derived_from";
    EdgeType["CAUSES"] = "causes";
    EdgeType["RESOLVES"] = "resolves";
    EdgeType["RELATED_TO"] = "related_to";
})(EdgeType || (EdgeType = {}));
export const edges = pgTable("edges", {
    id: uuid("id").primaryKey().defaultRandom(),
    companyId: uuid("company_id")
        .notNull()
        .references(() => organisations.id, { onDelete: "cascade" }),
    srcNodeId: uuid("src_node_id").notNull(),
    dstNodeId: uuid("dst_node_id").notNull(),
    edgeType: text("edge_type").notNull().$type(),
    createdAt: timestamp("created_at", { withTimezone: true }).notNull().defaultNow(),
}, table => ({
    companySrcIdx: index("idx_edges_company_src").on(table.companyId, table.srcNodeId),
    companyDstIdx: index("idx_edges_company_dst").on(table.companyId, table.dstNodeId),
    companyTypeIdx: index("idx_edges_company_type").on(table.companyId, table.edgeType),
}));
